<template>
    <div class="audio-file-info">
        <div class="info-icon">
            <i class="far fa-file-music background-icon" />
            <i class="far fa-check status-icon" />
        </div>

        <div class="file-actions">
            <div class="file-info">
                <span class="file-name">{{ episode.fileName }}</span>
                <span class="file-size">({{ fileSize }})</span>
            </div>

            <label class="reupload-label" for="reupload-input">
                <audio-file-input
                    id="reupload-input"
                    class="reupload-input"
                    @change="file => $emit('reupload', file)"
                />
                reupload file
            </label>
        </div>
    </div>
</template>
<script>
import prettyBytes from 'pretty-bytes';
import AudioFileInput from './AudioFileInput';
import episodeModal from '@/utils/episodeModal';

export default {
    components: {
        AudioFileInput,
    },

    computed: {
        /**
         * Gets the episode object.
         *
         * @returns {object} Episode object.
         */
        episode() {
            return episodeModal.getEpisode();
        },

        /**
         * Gets the pretty file size.
         *
         * @returns {string} Formatted file size.
         */
        fileSize() {
            return prettyBytes(this.episode.fileSize ?? 0, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).replace(/ /g, '');
        },
    },
};
</script>
